import { PageHero } from "../components/shared/PageHero";
import { Reveal } from "../components/shared/Reveal";

const COPY = {
  privacy: {
    eyebrow: "Legal",
    title: "Privacy Policy",
    body: "The full Kumite Games Privacy Policy is being prepared and will be published here. Kumite Games is committed to handling all personal information in accordance with the New Zealand Privacy Act.",
  },
  terms: {
    eyebrow: "Legal",
    title: "Terms & Conditions",
    body: "The full Kumite Games Terms & Conditions are being prepared and will be published here ahead of registrations and ticket sales.",
  },
};

export default function Legal({ type }) {
  const c = COPY[type] || COPY.privacy;
  return (
    <>
      <PageHero eyebrow={c.eyebrow} title={c.title} testId={`${type}-page-hero`} />
      <section className="mx-auto max-w-3xl px-5 pb-24 sm:px-8 sm:pb-32">
        <Reveal>
          <p data-testid={`${type}-content`} className="text-base leading-relaxed text-slate-400">
            {c.body}
          </p>
          <div className="gold-rule mt-12 w-24" />
          <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-600">
            © Kumite Games • New Zealand
          </p>
        </Reveal>
      </section>
    </>
  );
}
